import AbstractRequestTask from '../../AbstractRequestTask';

class CheckControlPinTask extends AbstractRequestTask {
  constructor(config, params) {
    super();
    this.config = config;
    this.params = params;
  }

  getUrl() {
    const domain = this.config.url_dominio_microfwk;

    return `${domain}services/user/checkcontrolpin`;
  }

  getParams() {
    const params = super.getParams(this.config);
    this.params = Object.assign(params, this.params);

    return params;
  }

  success(data) {
    const { status, response, errors } = data;
    if (!response && status > 0) return this.reject(new Error(errors));
    return this.resolve(data);
  }
}

export default CheckControlPinTask;
